import {
  Box,
  Button,
  Modal,
  Stack,
  Typography,
  TextField,
  CircularProgress,
  SelectChangeEvent,
  InputAdornment,
  IconButton,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Pagination,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import logoIkes from "../../media/logo-ikes.png";
import {
  createCourse,
  deleteCourse,
  getDetailCourseById,
  getListCourse,
  getListTime,
  uploadMedia,
  uploadMedias,
} from "./service";
import CreateCourse from "./components/course.create";
import CreateClass from "./components/class.create";
import { IoIosSearch } from "react-icons/io";
import { ListItemData } from "./interface";
import Masonry from "@mui/lab/Masonry";
import { format } from "date-fns";
import ListDetail from "./components/course.detail";
import CustomSnackbar from "components/snackbar";
import Time from "./components/course.time-available";
import SelectTeacher from "./components/select.teacher";
import { useListData } from "hooks/useListData";
import { getListUser } from "service/api/user.api";
import { getCookie } from "utils/setCookie";
import tiers from "./service/tiers.json";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { FaArrowLeft } from "react-icons/fa";
import { DataGrid } from "@mui/x-data-grid";
const initialFormData = {
  price: "",
  title: "",
  avatar: "",
  country: "country",
  version: "version",
  end_time: "",
  language: "en",
  media_id: "",
  media_video: "",
  class_duration: "",
  lession_count: 0,
  product_id: "product_id",
  start_time: "",
  description: "",
  trash_status: "trash_status",
  public_status: "draft",
  long_description: "",
  type: "Call 1-1",
  coupon_id: null,
};
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "800px",
  maxHeight: "600px",
  overflowY: "auto",
  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  bgcolor: "background.paper",
  borderRadius: "3px",
  p: 2,
};

const styleDetail = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "800px",
  maxHeight: "600px",
  overflowY: "auto",
  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  bgcolor: "background.paper",
  borderRadius: "3px",
};

const Course = () => {
  const itemsPerPage = 9;
  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openModalTime, setOpenModalTime] = useState(false);
  const [totalCourses, setTotalCourses] = useState(0);
  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingCir, setLoadingCir] = useState(false);
  const [loadingCirImage, setLoadingCirImage] = useState(false);
  const [loadingCirVideo, setLoadingCirVideo] = useState(false);
  const [type, setType] = useState("self-learning");
  const [getIdMedia, setGetIdMedia] = useState<string>("");
  const [mediaSrc, setMediaSrc] = useState<string>("");
  const [mediaSrcImage, setMediaSrcImage] = useState("");
  const [mediaSrcVideo, setMediaSrcVideo] = useState("");
  const [mediaType, setMediaType] = useState<string>("");
  const [getDataListCourse, setGetDataListCourse] = useState([]);
  const [getDetailCourse, setGetDetailCourse] = useState(null);
  const [dataLabels, setDataLabels] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showUploadButton, setShowUploadButton] = useState(true);
  const [showUploadButtonImage, setShowUploadButtonImage] = useState(true);
  const [showUploadButtonVideo, setShowUploadButtonVideo] = useState(true);
  const [dataMyCourse, setDataMyCourse] = useState([]);
  const [teacher, setTeacher] = useState("");
  const [showCreateCourse, setShowCreateCourse] = useState(false);
  const [showCreateClass, setShowCreateClass] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit = 10;

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [formData, setFormData] = useState<ListItemData>({
    price: "",
    title: "",
    avatar: "",
    // avatar: "67b7f9d75fc4a9adbaadb6d7",
    country: "country",
    version: "version",
    end_time: "",
    language: "en",
    media_id: "",
    // media_id: "67b7f9e05fc4a9adbaadb6dc",
    media_video: "",
    // media_video: "67b7f9e05fc4a9adbaadb6dc",
    class_duration: "",
    lession_count: 0,
    product_id: "product_id",
    start_time: "",
    description: "",
    trash_status: "trash_status",
    public_status: "active",
    long_description: "",
    type: "Call 1-1",
    coupon_id: null,
    teacher_id: "",
    teachers: [],
    limit_member: "",
    time_slot: "",
    course_days: [],
    students: [],
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getListCourse(searchQuery, currentPage, limit);
      const courseList = response.data;
      setGetDataListCourse(courseList);
      setTotalCourses(response.headers?.["x-total-count"]);
      setDataLabels(courseList.map((course) => course.labels).flat());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [searchQuery, currentPage]);

  const handleDetailsClick = async (id) => {
    try {
      const response = await getDetailCourseById(id);
      setGetDetailCourse(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
    setOpenModalDetail(true);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };
  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = () => {
    setFormData({
      price: "",
      title: "",
      avatar: "",
      country: "country",
      version: "version",
      end_time: "",
      language: "en",
      media_id: "",
      media_video: "",
      class_duration: "",
      lession_count: 0,
      product_id: "product_id",
      start_time: "",
      description: "",
      trash_status: "trash_status",
      public_status: "active",
      long_description: "",
      type: "Call 1-1",
      coupon_id: null,
      teacher_id: "",
      teachers: [],
      limit_member: "",
      time_slot: "",
      course_days: [],
      students: [],
    });
    setOpenModal(false);
    setMediaSrcImage(null);
    setMediaSrcVideo(null);
    setShowUploadButtonImage(true);
    setShowUploadButtonVideo(true);
  };

  const handleCancelCreateClass = () => {
    handleCloseModal();
    setShowCreateClass(false);
  };

  const handleOpenModalTime = async () => {
    setTeacher(null);
    setOpenModalTime(true);
  };

  // useEffect(() => {
  //   if (teacher) {
  //     getTeacherOneOneCalendar(teacher);
  //   }
  // }, [teacher]);

  // const getTeacherOneOneCalendar = async (teacher_id) => {
  //   const response = await getListTime(teacher_id);
  //   console.log("responseresponse", response);
  //   setDataMyCourse(response.data);
  // };

  const handleCloseModalTime = () => setOpenModalTime(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCloseModalDetail = () => setOpenModalDetail(false);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = page * itemsPerPage;

  const currentData = getDataListCourse.slice(startIndex, endIndex);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1);
  };

  const handleFileChangeAndUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      const files = event.target.files;
      if (files && files.length > 0) {
        setLoadingCir(true);

        const file = files[0];
        const headers = {
          "X-Authorization": getCookie("session"),
        };

        const uploadedFiles = await uploadMedia(file, headers);

        if (uploadedFiles.length > 0) {
          const { id, src } = uploadedFiles[0];

          if (file.type.startsWith("image/")) {
            setFormData((prevFormData) => ({
              ...prevFormData,
              avatar: id,
              media_id: null,
            }));
            setMediaType("image");
          } else if (file.type === "video/mp4") {
            setFormData((prevFormData) => ({
              ...prevFormData,
              media_id: id,
            }));
            setMediaType("video");
          }

          setShowUploadButton(false);
          setGetIdMedia(id);
          setMediaSrc(src);
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      console.log("Upload complete");
      setLoadingCir(false);
    }
  };

  const handleFileChangeAndUploadCallOneOne = async (event) => {
    try {
      const files = event.target.files;
      if (files && files.length > 0) {
        setLoadingCirImage(true);

        const file = files[0];
        const headers = {
          "X-Authorization": getCookie("session"),
        };

        const uploadedFiles = await uploadMedias(file, headers);

        if (uploadedFiles.length > 0) {
          const { id, src } = uploadedFiles[0];

          setFormData((prevFormData) => ({
            ...prevFormData,
            avatar: id,
            media_id: null,
          }));
          setMediaType("image");
          setShowUploadButtonImage(false);
          setMediaSrcImage(src);
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setLoadingCirImage(false);
    } finally {
      console.log("Upload complete");
      setLoadingCirImage(false);
    }
  };

  const handleFileChangeAndUploadCallVideo = async (event) => {
    try {
      const files = event.target.files;
      if (files && files.length > 0) {
        setLoadingCirVideo(true);

        const file = files[0];
        const headers = {
          "X-Authorization": getCookie("session"),
        };

        const uploadedFiles = await uploadMedias(file, headers);

        if (uploadedFiles.length > 0) {
          const { id, src } = uploadedFiles[0];

          setFormData((prevFormData) => ({
            ...prevFormData,
            media_video: id,
            media_id: id,
          }));
          setMediaType("video");
          setShowUploadButtonVideo(false);
          setMediaSrcVideo(src);
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      console.log("Upload complete");
      setLoadingCirVideo(false);
    }
  };

  const handleImageClick = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event: Event) => {
      handleFileChangeAndUpload(
        event as unknown as React.ChangeEvent<HTMLInputElement>
      );
    };
    input.click();
  };

  const handleImageClickOneOne = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event: Event) => {
      handleFileChangeAndUploadCallOneOne(
        event as unknown as React.ChangeEvent<HTMLInputElement>
      );
    };
    input.click();
  };

  const handleSubmit = async () => {
    if (
      (formData.type === "Call 1-1" || formData.type === "Call group") &&
      !formData.teacher_id
    ) {
      setSnackbarMessage("Bạn phải chọn giáo viên!");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    let price_id: string | null = null;
    if (formData.type !== "Call 1-1") {
      const selectedTier = tiers.find((tier) => tier.value === formData.price);
      price_id = selectedTier ? selectedTier.id : null;

      if (!price_id) {
        setSnackbarMessage("Lỗi: Không tìm thấy price_id phù hợp!");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
    }

    try {
      const response = await createCourse(
        price_id,
        String(formData.price),
        formData.title,
        formData.avatar,
        formData.country,
        formData.version,
        formData.end_time,
        formData.language,
        formData.media_id,
        formData.media_video,
        formData.class_duration,
        formData.lession_count,
        formData.product_id,
        formData.start_time,
        formData.description,
        formData.trash_status,
        formData.public_status,
        formData.long_description,
        formData.type,
        formData.coupon_id,
        formData.teacher_id,
        formData.skills,
        formData.level
      );

      setFormData(response.data);
      setGetDataListCourse((prevCourses) => [response.data, ...prevCourses]);
      setTotalCourses((prevTotal) => prevTotal + 1);
      handleCloseModal();
      setShowCreateCourse(false);
      setSnackbarMessage("Tạo thành công");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("error", error);
      const message = error?.response?.data?.message;
      setSnackbarMessage(
        message ? JSON.stringify(message) : "Có lỗi không xác định xảy ra!"
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSubmitClass = async () => {
    const teacher_ids = (formData.teachers || [])
      .map((t) => t._id)
      .filter(Boolean);
    const primaryTeacherId = teacher_ids[0] || "";
    const student_ids = (formData.students || [])
      .map((s) => s._id)
      .filter(Boolean);

    const limit_member =
      formData.limit_member === "" || formData.limit_member == null
        ? 0
        : Number(formData.limit_member);

    // Validate trước khi gửi: backend chỉ tạo lớp + lịch khi đủ các trường này
    const requiredChecks: [boolean, string][] = [
      [
        !Number.isInteger(limit_member) || limit_member < 1,
        "Bạn phải nhập số lượng người tham gia (từ 1 trở lên)!",
      ],
      [
        student_ids.length > limit_member,
        `Số học sinh (${student_ids.length}) vượt quá số lượng người tham gia (${limit_member})!`,
      ],
      [!primaryTeacherId, "Bạn phải chọn giảng viên!"],
      [!formData.title?.trim(), "Bạn phải nhập tiêu đề lớp học!"],
      [!formData.description?.trim(), "Bạn phải nhập mô tả lớp học!"],
      [
        formData.price === "" || isNaN(Number(formData.price)),
        "Bạn phải nhập giá khóa học hợp lệ!",
      ],
      [!formData.media_video, "Bạn phải tải video giới thiệu lớp học!"],
      [!formData.class_duration, "Bạn phải chọn số giờ học/buổi!"],
      [!formData.time_slot, "Bạn phải chọn khung giờ dạy!"],
      [!(formData.course_days || []).length, "Bạn phải chọn ít nhất 1 ngày dạy!"],
      [
        !formData.start_time || !formData.end_time,
        "Bạn phải chọn thời gian bắt đầu và kết thúc lớp học!",
      ],
      [
        !!formData.start_time &&
          !!formData.end_time &&
          formData.start_time > formData.end_time,
        "Ngày kết thúc phải sau ngày bắt đầu!",
      ],
    ];
    const failed = requiredChecks.find(([invalid]) => invalid);
    if (failed) {
      setSnackbarMessage(failed[1]);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    // Giá do admin tự điền; nếu khớp 1 tier có sẵn thì gắn kèm price_id, không bắt buộc
    const selectedTier = tiers.find(
      (tier) => tier.value === Number(formData.price)
    );
    const price_id: string | null = selectedTier ? selectedTier.id : null;

    // Lịch học: mỗi ngày dạy được chọn tạo 1 buổi với cùng khung giờ + số giờ/buổi
    const duration = parseFloat(String(formData.class_duration)) || 0;
    const course_calendars = formData.time_slot
      ? (formData.course_days || []).map((day) => ({
          day,
          time_start: formData.time_slot,
          time_duration: duration,
        }))
      : [];

    // Gọi 1-1 bắt buộc lession_count: đếm số buổi rơi vào các ngày dạy trong khoảng thời gian lớp
    // (course_days: 0 = Thứ 2 ... 6 = Chủ nhật; Date.getDay(): 0 = Chủ nhật)
    let lession_count = formData.lession_count;
    if (formData.type === "Call 1-1") {
      lession_count = 0;
      const cursor = new Date(`${formData.start_time}T00:00:00`);
      const last = new Date(`${formData.end_time}T00:00:00`);
      while (cursor <= last) {
        if ((formData.course_days || []).includes((cursor.getDay() + 6) % 7)) {
          lession_count++;
        }
        cursor.setDate(cursor.getDate() + 1);
      }
      if (!lession_count) {
        setSnackbarMessage("Không có buổi học nào trong khoảng thời gian đã chọn!");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
    }

    try {
      const response = await createCourse(
        price_id,
        String(formData.price),
        formData.title,
        formData.avatar,
        formData.country,
        formData.version,
        formData.end_time,
        formData.language,
        formData.media_id,
        formData.media_video,
        formData.class_duration,
        lession_count,
        formData.product_id,
        formData.start_time,
        formData.description,
        formData.trash_status,
        formData.public_status,
        formData.long_description,
        formData.type,
        formData.coupon_id,
        primaryTeacherId,
        formData.skills,
        formData.level,
        {
          teacher_ids,
          limit_member,
          course_calendars,
          student_ids,
          // Khoá lớp học của trung tâm: không bán online, ẩn/hiện trên app theo công tắc ở Config
          is_center_class: true,
        }
      );

      setGetDataListCourse((prevCourses) => [response.data, ...prevCourses]);
      setTotalCourses((prevTotal) => prevTotal + 1);
      handleCancelCreateClass();

      // Lớp đã tạo nhưng có học sinh không thêm được → báo lại để admin thêm tay
      const failedStudents: string[] = response.data?.failed_student_ids || [];
      const chatFailedStudents: string[] =
        response.data?.chat_failed_student_ids || [];
      const chatRoomCreated = response.data?.chat_room_created !== false;
      const studentNames = (ids: string[]) =>
        (formData.students || [])
          .filter((s) => ids.includes(s._id))
          .map((s) => s.display_name || s._id)
          .join(", ");
      const warnings: string[] = [];
      if (failedStudents.length) {
        warnings.push(`chưa thêm được học sinh: ${studentNames(failedStudents)}`);
      }
      if (!chatRoomCreated) {
        warnings.push("chưa tạo được nhóm chat cho lớp");
      } else if (chatFailedStudents.length) {
        warnings.push(
          `chưa thêm được vào nhóm chat: ${studentNames(chatFailedStudents)}`
        );
      }
      if (warnings.length) {
        setSnackbarMessage(`Tạo lớp học thành công, nhưng ${warnings.join("; ")}`);
        setSnackbarSeverity("error");
      } else {
        setSnackbarMessage("Tạo lớp học thành công");
        setSnackbarSeverity("success");
      }
      setSnackbarOpen(true);
    } catch (error) {
      console.error("error", error);
      const message = error?.response?.data?.message;
      setSnackbarMessage(
        message ? JSON.stringify(message) : "Có lỗi không xác định xảy ra!"
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleChangeSkills = (event) => {
    const {
      target: { value },
    } = event;
    setFormData({
      ...formData,
      skills: typeof value === "string" ? value.split(",") : value,
    });
  };

  const handleDelete = async (id) => {
    try {
      await deleteCourse(id);
      setGetDataListCourse((prevCourses) =>
        prevCourses.filter((course) => course._id !== id)
      );
      setTotalCourses((prevTotal) => prevTotal - 1);

      setSnackbarMessage("Xóa thành công");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      setOpenModalDetail(false);
    } catch (error) {
      setSnackbarMessage("Xóa thất bại");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  const handleChangeCourse = (field: string, value: string) => {
    console.log("first", field, value);
    let parsedValue: number | string;

    if (field === "lession_count") {
      const intValue = parseInt(value, 10);

      parsedValue = isNaN(intValue) ? 0 : intValue;
    } else {
      parsedValue = value;
    }

    setFormData({
      ...formData,
      [field]: parsedValue,
    });
  };

  const formattedAmount = new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  });

  const statusColorMap = {
    active: "success",
    pending: "error",
  };

  const statusName = {
    draf: "Bản nháp",
    active: "Hoạt động",
    pending: "Chờ duyệt",
  };

  function formatDate(isoString) {
    const date = new Date(isoString);
    return format(date, "'Ngày' dd 'tháng' MM 'năm' yyyy");
  }

  const columns = [
    {
      field: "title",
      headerName: "Tên khóa học",
      flex: 3,
      minWidth: 250,
      renderCell: (params) => (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ display: "flex", height: "100%" }}
        >
          <img
            src={params.row.avatar?.media_url || logoIkes}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = logoIkes;
            }}
            width={40}
            height={40}
            style={{ borderRadius: 8, objectFit: "cover" }}
          />
          <Typography>{params.row.title}</Typography>
        </Stack>
      ),
    },

    {
      field: "display_name",
      headerName: "Giảng viên",
      flex: 1,
      renderCell: (params) =>
        params.row?.user_id?.display_name || "Unknown User",
    },
    {
      field: "price",
      headerName: "Giá",
      flex: 1,
      renderCell: (params) => formattedAmount.format(params.row.price),
    },
    {
      field: "public_status",
      headerName: "Trạng thái",
      flex: 1,
      renderCell: (params) => (
        <Chip
          label={statusName[params.row.public_status]}
          sx={{
            backgroundColor:
              params.row.public_status === "active" ? "#50C878" : "#FF5733",
            color: "#fff",
          }}
        />
      ),
    },
    {
      field: "review_count",
      headerName: "Đánh giá",
      flex: 1,
      renderCell: (params) =>
        params.row.review_count === 0
          ? "Chưa có đánh giá"
          : `Có ${params.row.review_count} đánh giá`,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1450px",
        margin: "0 auto",
        padding: 2,
        bgcolor: "#F1F1F1",
      }}
    >
      {!showCreateCourse && !showCreateClass && (
        <Box>
          <Modal
            open={openModalDetail}
            onClose={handleCloseModalDetail}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <ListDetail
              fetchData={fetchData}
              statusName={statusName}
              handleDelete={handleDelete}
              styleDetail={styleDetail}
              getDetailCourse={getDetailCourse}
              formattedAmount={formattedAmount}
              formatDate={formatDate}
              statusColorMap={statusColorMap}
              handleSnackbarClose={handleSnackbarClose}
              setSnackbarSeverity={setSnackbarSeverity}
              setSnackbarMessage={setSnackbarMessage}
              setSnackbarOpen={setSnackbarOpen}
            />
          </Modal>

          <Modal
            open={openModalTime}
            onClose={handleCloseModalTime}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <SelectTeacher
                selectItem={teacher}
                callback={setTeacher}
                customWidth={"33%"}
              />
              {!!teacher ? (
                <Time
                  id={teacher}
                  setSnackBarMessage={setSnackbarMessage}
                  setSnackbarSeverity={setSnackbarSeverity}
                  setSnackbarOpen={setSnackbarOpen}
                  dataMyCourse={dataMyCourse}
                />
              ) : (
                <Typography>Bạn chưa chọn giáo viên!</Typography>
              )}
            </Box>
          </Modal>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" fontWeight={550}>
              Danh sách Khóa học
            </Typography>
            <Stack direction="row" gap={1.5}>
              <Button
                onClick={() => {
                  setFormData((prev) => ({ ...prev, type: "Call group" }));
                  setShowCreateClass(true);
                }}
                variant="outlined"
                sx={{
                  fontWeight: 550,
                  height: "45px",
                  color: "#B32519",
                  borderColor: "#B32519",
                  "&:hover": {
                    borderColor: "#B32519",
                    bgcolor: "rgba(179,37,25,0.04)",
                  },
                }}
              >
                Thêm lớp học
              </Button>
              <Button
                onClick={() => setShowCreateCourse(true)}
                variant="contained"
                color="success"
                sx={{
                  fontWeight: 550,
                  height: "45px",
                  bgcolor: "#B32519",
                  "&:hover": { bgcolor: "#B32519" },
                }}
              >
                Tạo khóa học
              </Button>
            </Stack>
          </Stack>

          <Box
            sx={{
              backgroundColor: "#fff",
              width: "100%",
              mt: 3,
              borderRadius: "3px",
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
          >
            <Stack
              direction="row"
              mb={2}
              p={3}
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" gap={2} alignItems="center">
                <TextField
                  placeholder="Tìm kiếm khóa học"
                  size="small"
                  variant="outlined"
                  sx={{ width: "100%", maxWidth: "250px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end">
                          <IoIosSearch />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </Stack>
              <Button
                onClick={handleOpenModalTime}
                variant="contained"
                color="success"
                sx={{
                  fontWeight: 550,
                  height: "45px",
                  bgcolor: "#B32519",
                  "&:hover": { bgcolor: "#B32519" },
                }}
              >
                Chỉnh sửa thời gian khóa học 1-1
              </Button>
            </Stack>

            <Box>
              {/* <Box p={1.5}>
                <Stack direction="row" gap={2} alignItems="center">
                  <Typography variant="body2">Tất cả</Typography>
                  <Typography variant="body2">Thể loại khóa</Typography>
                </Stack>
              </Box>

              <DataGrid
                rows={getDataListCourse}
                columns={columns}
                rowCount={totalCourses}
                paginationMode="server"
                initialState={{
                  pagination: {
                    paginationModel: { page: currentPage - 1, pageSize: limit },
                  },
                }}
                onPaginationModelChange={(paginationModel) => {
                  setCurrentPage(paginationModel.page + 1);
                }}
                sx={{
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "bold",
                  },
                  "& .MuiDataGrid-row": {
                    marginBottom: "8px",
                  },
                }}
                pageSizeOptions={[5, 10]}
                getRowId={(row) => row._id}
                onRowClick={(params) => handleDetailsClick(params.row?._id)}
              /> */}

              <Masonry
                columns={3}
                spacing={2}
                sx={{ margin: "0 auto !important" }}
              >
                {currentData.map((course, index) => (
                  <Card
                    key={index}
                    onClick={() => handleDetailsClick(course._id)}
                    sx={{
                      maxWidth: 400,
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                      "&:hover": {
                        backgroundColor: "rgba(251, 251, 251, 0.6)",
                      },
                      cursor: "pointer",
                      zIndex: "1",
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="194"
                      image={course?.avatar?.media_url || logoIkes}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = logoIkes;
                      }}
                      alt=""
                    />
                    <CardContent sx={{ color: "#333" }}>
                      <Stack
                        direction="row"
                        gap={1}
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography
                          variant="body1"
                          fontWeight={550}
                          mt={1}
                          mb={1}
                        >
                          {course.title}
                        </Typography>
                        <Chip
                          label={statusName[course.public_status]}
                          color={statusColorMap[course.public_status]}
                          sx={{
                            backgroundColor:
                              course.public_status === "active"
                                ? "#50C878"
                                : "#FF5733",
                            color: "#fff",
                          }}
                        />
                      </Stack>
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        mt={1}
                        mb={1}
                      >
                        {course.user_id?.display_name || "Unknown User"}
                      </Typography>
                      <Typography variant="body2" fontWeight={550}>
                        {formattedAmount.format(course.price)}
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {course.review_count === 0 ? (
                          <Typography
                            variant="body2"
                            fontWeight={500}
                            fontSize={12}
                          >
                            Chưa có đánh giá
                          </Typography>
                        ) : (
                          <Typography variant="body2" fontWeight={500}>
                            Có {course.review_count} đánh giá
                          </Typography>
                        )}
                      </Typography>
                      {course.labels &&
                        course.labels.map((label, index) => (
                          <Chip key={index} label={label} />
                        ))}
                    </CardContent>
                  </Card>
                ))}
              </Masonry>
              <Pagination
                count={Math.ceil(totalCourses / limit)}
                page={currentPage}
                onChange={(event, value) => setCurrentPage(value)}
                variant="outlined"
                shape="rounded"
              />
            </Box>
          </Box>
        </Box>
      )}

      {showCreateCourse ? (
        <Box p={2} borderRadius="8px" height="100vh">
          <Box display="flex" alignItems="center" mb={2}>
            <IconButton
              onClick={() => {
                handleCloseModal();
                setShowCreateCourse(false);
              }}
              sx={{ mr: 1 }}
            >
              <FaArrowLeft fontSize={15} />
            </IconButton>
            <Typography variant="h6" fontWeight={550}>
              Tạo khóa học
            </Typography>
          </Box>

          <CreateCourse
            handleImageClickOneOne={handleImageClickOneOne}
            showUploadButton={showUploadButton}
            showUploadButtonImage={showUploadButtonImage}
            showUploadButtonVideo={showUploadButtonVideo}
            loadingCir={loadingCir}
            loadingCirImage={loadingCirImage}
            loadingCirVideo={loadingCirVideo}
            mediaSrc={mediaSrc}
            handleChangeSkills={handleChangeSkills}
            mediaSrcVideo={mediaSrcVideo}
            mediaSrcImage={mediaSrcImage}
            mediaType={mediaType}
            handleChangeCourse={handleChangeCourse}
            handleSubmit={handleSubmit}
            formData={formData || {}}
            style={style || {}}
            handleFileChangeAndUpload={handleFileChangeAndUpload}
            handleFileChangeAndUploadCallOneOne={
              handleFileChangeAndUploadCallOneOne
            }
            handleFileChangeAndUploadCallVideo={
              handleFileChangeAndUploadCallVideo
            }
            type={type}
            handleChange={handleChange}
          />
        </Box>
      ) : null}

      {showCreateClass ? (
        <Box p={2} borderRadius="8px">
          <Box display="flex" alignItems="center" mb={2}>
            <IconButton onClick={handleCancelCreateClass} sx={{ mr: 1 }}>
              <FaArrowLeft fontSize={15} />
            </IconButton>
            <Typography variant="h6" fontWeight={550}>
              Thêm lớp học
            </Typography>
          </Box>

          <CreateClass
            onCancel={handleCancelCreateClass}
            handleImageClickOneOne={handleImageClickOneOne}
            showUploadButton={showUploadButton}
            showUploadButtonImage={showUploadButtonImage}
            showUploadButtonVideo={showUploadButtonVideo}
            loadingCir={loadingCir}
            loadingCirImage={loadingCirImage}
            loadingCirVideo={loadingCirVideo}
            mediaSrc={mediaSrc}
            handleChangeSkills={handleChangeSkills}
            mediaSrcVideo={mediaSrcVideo}
            mediaSrcImage={mediaSrcImage}
            mediaType={mediaType}
            handleChangeCourse={handleChangeCourse}
            handleSubmit={handleSubmitClass}
            formData={formData || {}}
            style={style || {}}
            handleFileChangeAndUpload={handleFileChangeAndUpload}
            handleFileChangeAndUploadCallOneOne={
              handleFileChangeAndUploadCallOneOne
            }
            handleFileChangeAndUploadCallVideo={
              handleFileChangeAndUploadCallVideo
            }
            type={type}
            handleChange={handleChange}
          />
        </Box>
      ) : null}
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};

export default Course;
